import { ReactNode } from 'react';
import {
  Button,
  Dialog, DialogActions, DialogTitle, IconButton,
} from '@mui/material';
import { useTranslate } from 'ra-core';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const StepDialogCard = (props: {
  open: boolean;
  title: string;
  content: ReactNode;
  onClose: () => void;
  nextLabel?: string;
  onNext?: () => void;
  hintText?: string;
  nextDisabled?: boolean;
  onBack?: () => void;
  fullPage?: boolean;
}) => {

  const translate = useTranslate();
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      fullWidth={!props.fullPage}
      maxWidth={props.fullPage ? undefined : 'lg'}
      fullScreen={props.fullPage}
      transitionDuration={0}
      sx={{ zIndex: 7 }}
      PaperProps={{
        sx: {
          height: props.fullPage ? '100%' : undefined,
          borderRadius: '0',
        },
      }}
    >
      <DialogTitle className="flex-in-between">
        <div style={{
          display: 'flex',
          alignItems: 'center',
          minHeight: '2.5em',
        }}>
          {props.onBack
          && <IconButton onClick={props.onBack} sx={{ marginLeft: '-10px', marginRight: '10px' }}>
            <ArrowBackIcon />
          </IconButton>
          }
          <span>{translate(props.title)}</span>
        </div>
        <>
          {!props.fullPage && (
            <IconButton onClick={props.onClose}>
              <CloseIcon fontSize="large" />
            </IconButton>
          )}
        </>
      </DialogTitle>
      {props.content}
      {(props.onNext || props.hintText) && (
        <DialogActions className="building-add-actions">
          <div>
            {props.hintText && (
              props.hintText
            )}
          </div>
          {props.onNext && (
            <Button
              onClick={props.onNext}
              color="primary"
              variant={'contained'}
              size="large"
              disabled={props.nextDisabled}
            >
              {translate(props.nextLabel || 'ra.navigation.next')}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );

};
